import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BaseComponent } from 'app/components/base.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { ModalType } from 'app/components/modals/modal.const';
import { FormFieldType } from 'app/components/modals/modal-form-template/modal-form.const';
import { GetQCCategoryQuery, QCCategory, SmartQcService } from 'app/common/services/SmartQC.service';
import { TableAction } from 'app/components/table-component/table.const';
import {
  buildCreateQCCategoryModel,
  buildEditQCCategoryModel,
  buildTableColumns,
  FormFieldCode,
} from './setting-category.util';

type ModalAction = 'add' | 'edit' | 'close';

@Component({
  selector: 'app-smart-qc-setting-category',
  templateUrl: './setting-category.component.html',
  providers: [SmartQcService],
})
export class SettingCategoryComponent extends BaseComponent {
  @ViewChild('template') template: ElementRef;
  public loading: boolean = false;
  public keyword: string = '';
  public qcCategories: QCCategory[] = [];
  private _currentQCCategory: QCCategory = null;
  public currentPage: number = 1;
  public pageSize: number = 10;
  public totalPage: number = 0;
  public totalItems: number = 0;
  public modalAction: ModalAction = 'close';
  public tableColumns: any[] = [];

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private smartQCService: SmartQcService
  ) {
    super(changeDetector, toastr, modalService);
  }

  ngOnInit(): void {
    this.tableColumns = buildTableColumns();
    this.getQCCategories();
  }

  getQCCategories() {
    this.loading = true;

    const query: GetQCCategoryQuery = {
      page: this.currentPage,
      page_size: this.pageSize,
    };

    const name = this.keyword.trim();
    if (name) {
      query.name = name;
    }

    this.smartQCService.getQCCategories(query).subscribe(
      ({ data }) => {
        this.loading = false;
        this.qcCategories = data.data;
        this.totalItems = data.total;
        this.totalPage = Math.ceil(data.total / this.pageSize);
      },
      error => {
        this.loading = false;
        this.throwError(error.message);
      }
    );
  }

  handleSearch() {
    const keyword = this.keyword.trim();
    if (!keyword) {
      this.throwError('Nhập thông tin để tìm kiếm');
      return;
    }

    this.currentPage = 1;
    this.getQCCategories();
  }

  initModal() {
    this.modelContent = {
      type: ModalType.Primary,
      title: this.modalAction === 'add' ? 'Thêm mới danh mục' : 'Cập nhật danh mục',
      submit_title: this.modalAction === 'add' ? 'Thêm mới' : 'Cập nhật',
      close_title: 'Hủy bỏ',
    };

    this.modelDisplay = [
      {
        key: FormFieldCode.NAME,
        label: 'Tên danh mục',
        placeholder: 'Nhập tên danh mục',
        type: FormFieldType.Text,
        value: this.model[FormFieldCode.NAME],
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
      },
      {
        key: FormFieldCode.DESCRIPTION,
        label: 'Mô tả danh mục',
        placeholder: 'Nhập mô tả danh mục',
        type: FormFieldType.Textarea,
        value: this.model[FormFieldCode.DESCRIPTION],
        required: false,
        disabled: false,
        width: 'full',
        order: 1,
      },
    ];
  }

  handleCloseModal() {
    this.modalAction = 'edit';
    this.closeModal();
  }

  handleOpenModal(modalAction: ModalAction) {
    this.modalAction = modalAction;
    this.model =
      modalAction === 'add' ? buildCreateQCCategoryModel() : buildEditQCCategoryModel(this._currentQCCategory);

    this.initModal();

    this.openModal(
      this.template,
      {
        backdrop: true,
        ignoreBackdropClick: true,
        class: 'modal-xl',
        keyboard: false,
      },
      {},
      {
        modelContent: this.modelContent,
        modelDisplay: this.modelDisplay,
      }
    );
  }

  async handleTableAction(event: TableAction, qcCategory: QCCategory) {
    if (event === TableAction.delete) {
      const okDeleteQCCategory = confirm('Bạn có muốn xóa danh mục này không?');
      if (okDeleteQCCategory) {
        this.smartQCService.deleteQCCategory(qcCategory._id).subscribe(
          () => {
            this.throwSuccess('Xóa thành công');
            this.getQCCategories();
          },
          error => {
            this.throwError(error.message);
          }
        );
      }
    } else if (event === TableAction.edit) {
      this._currentQCCategory = qcCategory;
      this.handleOpenModal('edit');
    }
  }

  async handleSubmit(model: any) {
    let observable: Observable<any>;

    if (this.modalAction === 'add') {
      observable = this.smartQCService.createQCCategory(model);
    } else if (this.modalAction === 'edit') {
      observable = this.smartQCService.updateQCCategory(this._currentQCCategory._id, model);
    }

    observable.subscribe(
      () => {
        const message = this.modalAction === 'add' ? 'Thêm mới thành công' : 'Cập nhật thành công';

        this.throwSuccess(message);
        this.getQCCategories();
        this.handleCloseModal();
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };

        setTimeout(() => {
          this.message = null;
        }, 3000);
      }
    );
  }

  async onChangeValueModel(_fieldCode: FormFieldCode, qcCategory: any) {
    this.model = qcCategory;
  }

  setPage(page: number) {
    let newPage: number = page;
    if (page < 1) {
      newPage = 1;
    }

    if (page > this.totalPage) {
      newPage = this.totalPage;
    }

    if (newPage !== this.currentPage) {
      this.currentPage = newPage;
      this.getQCCategories();
    }
  }

  goPage2(page: string) {
    let toPage: any = page;
    if (!toPage) {
      toPage = 1;
    }

    if (Number.isInteger(toPage) && toPage <= 0) {
      toPage = 1;
    }

    this.setPage(toPage);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/smart-qc/setting/category/setting-category.component.ts